import PublicLayout from '../components/layouts/PublicLayout';
import { Container, Row, Col } from 'reactstrap';
import { useState, useEffect} from 'react';
import AboutWhy from '../public/public/about-why.jpg';
import AboutTool1 from '../public/public/about-tool1.png';
import AboutTool2 from '../public/public/about-tool2.png';
import AboutTool3 from '../public/public/about-tool3.png';
import AboutWhatDo from '../public/public/about-wht-do.jpg';
import Link from 'next/link';
import Image from 'next/image';
import axios from 'axios';
import Head from 'next/head';
import { useRouter } from 'next/router';
import DefaultImage from '../public/public/preview-image.jpg';

function About({meta}) {
    const [loading, setLoading] = useState(false); 
    
	const router = useRouter();
	return (
        <>
       <Head>
			<meta name="keywords" content={meta ? meta.keywords : ''} />
			<title>{meta ? meta.title : ''}</title>
			<meta name="description" content={meta ? meta.description : ''} />
			<link rel="canonical" href={process.env.NEXT_PUBLIC_APP_URL + router.asPath} />
		</Head>
			<div className="banner_breadcrumb_section" id="about">
					<div id="spinner" className="spinner_req_review" style={{"display": loading ? "block" : "none"}}>
						<div className="lds-spinner"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
					</div>
				  	<Container fluid="xl">
						<h1 className="main-heading-lg">About Us</h1>
					</Container>
				</div>
				  <Container fluid="xl">
					  <div className="about_sec1-intro text-center top-spacing" >
					  <p className="description-text">We&#39;re the leading platform for top talents in multiple industries. It&#39;s easier than ever to get skilled vendors and agencies working on your projects. We have a solution oriented approach that gets you to complete your tasks right on time.</p>
					  </div>
					  <div className="about_why-toprow padding-wrap placeholder_align">
						  <Row>
							  <Col md="6">
								<div className="reset_img">
								<Image src={AboutWhy} alt="about why" className="shadow-image bg_placeholder" layout='fill' style={{ backgroundImage: `url(${DefaultImage.src})` }} />
								</div>
							  </Col>
							  <Col md="6">
								  <div className="right_col">
								  <h2 className="main-heading">Why Toprow?</h2>
								  <p className="description-text-sm">Toprow is the platform for forward thinking enterprises and smart talent. Our marketplace provides businesses with highly skilled professionals. If you&#39;re a business looking to execute projects that drive business growth, you will find experts here that can get the job done. Our professionals are vetted and verified to ensure effective collaboration between your business and industry experts.</p>
								  </div>
							  </Col>
						  </Row>
					  </div>

					  <div className="about_grid padding-wrap">
						  <Row>
							  <Col md="4">
								  <div className="d-flex flex-row">
									<div className="">
									<div className="btn-soft-primary me-4">
											<span className=""><i className="fa fa-cog" aria-hidden="true"></i></span>
										</div>
									</div>
									<div className="about_grid_content">
										<h4>Enhanced Productivity</h4>
										<p className="description-text-sm">Focus on your numbers while an expert helps you with specified projects.</p>
									</div>
								  </div>
							 	</Col>
							  <Col md="4">
							  <div className="d-flex flex-row">
									<div className="">
									<div className="btn-soft-primary me-4">
										<span className=""><i className="fa fa-cog" aria-hidden="true"></i></span>
										</div>
									</div>
									<div className="about_grid_content">
										<h4>Accelerate Results</h4>
										<p className="description-text-sm">Do more faster. With a professional working on your next big project, you can be rest assured of topnotch outcomes. </p>
									</div>
								  </div> 
							  </Col>
							  <Col md="4">
							  <div className="d-flex flex-row">
									<div className="">
										<div className="btn-soft-primary me-4">
										<span className=""><i className="fa fa-cog" aria-hidden="true"></i></span>
										</div>
									</div>
									<div className="about_grid_content">
										<h4>Drive Efficiency</h4>
										<p className="description-text-sm">Run your business more easily with help from a Toprow talent. Reduce cost significantly while getting an expert working on that task. </p>
									</div>
								  </div>
							  </Col>
							  <Col md="12" lg="12">
								  <div className="content_ab_wrap about_sec1-intro">
									<p className="description-text-sm text-center">Every vendor on Toprow is operating a business that allows them to understand you and affords them knowledge of how crucial your projects are to driving success. Spark innovation by hiring someone with the unique set of skills that your project requires.</p>
									<div className="text-center learn-how">
									<a class="primary-btn" href="#"><span>Learn How to Get Started</span></a>
									</div>
								  </div>
							  </Col>
						  </Row>
					  </div>
				  </Container>
				  <div className="about-tools-section padding-wrap">
					<Container fluid="xl">
						<div className="text-center tools-upper-section">
						<h4 className="main-heading">The Tools You Need to Hire Right</h4>
						<p className="description-text-sm">Here at Toprow, we provide you all the tools you need to make the right hiring decision. Evaluate each vendor&#39;s portfolio and view testimonials from their past projects. Our support team is always available to help you along the way.</p>
						</div>
						<ul className="tool-listing-section reset_img">
							<li>
								<div className="tools-listing-inner">
									<div className="list_head">
									<Image src={AboutTool1} alt="about tool" unoptimized={true} layout='fill' />
									<h5>Trust Metrics</h5>
									</div>
								   <div className="content-section">
									<p className="description-text-sm">The vendors on Toprow are carefully selected to meet the needs of business owners so that projects are completed effectively and efficiently. Vendors are evaluated every year to keep performance high on every project.</p>
								   </div>
								   <p className="list_number">01</p>
								</div>
							</li>
							<li>
								<div className="tools-listing-inner">
									<div className="list_head">
									<Image src={AboutTool2} alt="about tool" unoptimized={true} layout='fill' />
									<h5>Read & Share Reviews</h5>
									</div>
									<div className="content-section">
										<p className="description-text-sm">You can check reviews from other businesses before you hire a vendor. When your project is completed, you can also leave a testimonial. This keeps our marketplace secure enough to retain only top talent.
										<br/>
										<br/>
										</p>
									</div>
									<p className="list_number">02</p>
								</div>
							</li>
							<li>
								<div className="tools-listing-inner">
									<div className="list_head">
									<Image src={AboutTool3} alt="about tool" unoptimized={true} layout='fill' />
									<h5>Find Pros in Your Area</h5>
									</div>
								   <div className="content-section">
									<p className="description-text-sm">Search for vendors by location. You can find the right talent for your project in your local area. Want a vendor who is close to you? You will surely find lots of them using the appropriate search metric.
									<br/>
									<br/>
									</p>
								   </div>
								   <p className="list_number">03</p>
								</div>
							</li>
						</ul>
					</Container>
				  </div>
				  <Container fluid="xl">
					  <div className="padding-wrap wht-do-about-section placeholder_align">       
					  <Row>
						  <Col md="6">
							  <div className="left_col_block">  
									<h3 className="main-heading">What We Do?</h3>
									<p className="description-text-sm">We provide a single destination for businesses and vendors to collaborate on projects. We are the leading marketplace for matching businesses and vendors and getting work done faster. The talents on Toprow can help you concentrate on other parts of your business while accomplishing your most important tasks.</p>
							  </div>
						  </Col>
							<Col md="6" className="text-right reset_img img_right">
							<Image src={AboutWhatDo} alt="about what" className="shadow-image bg_placeholder" layout='fill' style={{ backgroundImage: `url(${DefaultImage.src})` }} />
						  </Col>
					  </Row>
					  </div>
				  </Container>
				  <div className="home-quote-started_section">
					<Container fluid="xl">
						<div className="padding-wrap text-center">    
						<h4 className="main-heading-lg">Get Started Today</h4>
							<p className="description-text-sm">
							Find the right agency for your next big project
							</p>
							<Link href="/"><a className="primary-btn"><span>Get a Quote</span></a></Link>
						</div>
					</Container>
				</div>
        </>
	)
}

// This gets called on every request
export async function getServerSideProps({ req, res}) {
    try {
        const response = await axios.get(process.env.NEXT_PUBLIC_API_URL+'metas?path=/about', { headers: {
            "Accept": "application/json" }
        });

        return { props: { meta: response.data.data,  } }

    } catch (err) {
        const meta = false;

        return { props: { meta } };
    }
}

About.Layout = PublicLayout;

export default About
